import React from "react";
import { Control, FieldValues, Path, useController } from "react-hook-form";
import styles from "./Select.module.scss";
import { clx } from "../utils/stringUtils";
import ReactSelect from "react-select";
import { filtersConfig, OptionType } from "../utils/reactSelectUtils";
import { useAppSelector } from "@src/store/hooks";

export interface IInputProps<T extends FieldValues> {
	control: Control<T>;
	options: Array<OptionType>;
	name: Path<T>;
	label?: string;
	controlSize?: "m" | "sm";
	disableErrorMessage?: boolean;
	isClearable?: boolean;
	isLoading?: boolean;
	placeholder?: string;
	wrapperStyle?: React.CSSProperties;
	bg?: { light: string; dark: string };
}

export const Select = <T extends FieldValues>({
	label,
	controlSize = "m",
	options = [],
	control,
	name,
	disableErrorMessage,
	isClearable,
	isLoading,
	placeholder,
	wrapperStyle,
	bg,
}: IInputProps<T>): React.ReactElement => {
	const { field, fieldState } = useController({ name, control });
	const errorMessage = fieldState.error?.message;
	const { isDirty, invalid } = fieldState;
	const fieldValue = field?.value;
	const value = fieldValue ? { label: fieldValue, value: fieldValue } : null;

	const innerTernary = field.value && isDirty ? "success" : "none";
	const inputStatus = invalid ? "error" : innerTernary;
	const theme = useAppSelector((state) => state.settings.theme);

	const customStyles = filtersConfig(inputStatus, theme, bg);

	return (
		<div className={clx({ [styles.main]: true, [styles.small]: controlSize == "sm" })} style={wrapperStyle}>
			{label && <div className={styles.label}>{label}</div>}
			{/* <select className={styles.select} data-input-status={inputStatus} {...requiredProps}>
				{options.map((x) => (
					<option key={x.value} value={x.value}>
						{x.label}
					</option>
				))}
			</select> */}
			<ReactSelect
				isClearable={isClearable}
				isLoading={isLoading ?? false}
				options={options}
				placeholder={placeholder}
				onChange={(data) => {
					const single = data as OptionType | null;
					field.onChange(single?.value ?? "");
				}}
				value={value}
				isMulti={false}
				styles={customStyles}
				components={{ IndicatorSeparator: null }}
			/>
			{!disableErrorMessage && errorMessage && (
				<div className={styles.status} data-input-status={inputStatus}>
					{errorMessage}
				</div>
			)}
		</div>
	);
};
